module.exports = __webpack_public_path__ + "static/media/rain.df08b428.jpg";